import { Injectable } from "@angular/core";

@Injectable({
    'providedIn': 'root'
})

export class VariablesGlobales {

  //URL_API : string = 'http://192.168.1.250/hcy/back/api';
  //URL_API_IMPR : string = 'http://192.168.1.250/hcy/back/';
  //URL_API : string = 'http://localhost:8000/api/';
  //URL_API_IMPR : string = 'http://localhost:8000/';
  URL_API : string = 'https://v5-test-api.sigelam.com/api/';
  URL_API_IMPR : string = 'https://v5-test-api.sigelam.com/';

}
